function initRitualVideo(root) {
  if (!root) return;
 
  const playButton = root.querySelector('[data-ritual-play]');
  const video = root.querySelector('.ritual-video__element');
 
  if (!playButton || !video) return;
 
  playButton.addEventListener('click', () => {
    video.setAttribute('controls', '');
    video.play();
    root.classList.add('is-playing');
  });
 
  video.addEventListener('pause', () => {
    root.classList.remove('is-playing');
  });
 
  video.addEventListener('ended', () => {
    root.classList.remove('is-playing');
  });
}
 
function initAllRitualVideos() {
  document.querySelectorAll('[data-ritual-video]').forEach(initRitualVideo);
}
 
document.addEventListener('DOMContentLoaded', initAllRitualVideos);
 
document.addEventListener('shopify:section:load', (event) => {
  const root = event.target.querySelector('[data-ritual-video]');
  if (root) initRitualVideo(root);
});
 